// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
export interface IContact {
    request: string; // problem, feature, comment
    product: string; // app, sentinel, other
    message: string; // customer description of problem
    devinfo: string; // information about the device that sent the request
}

export const SupportInfo = {
    url: 'https://support.cigent.com/support/home'
};
